// 只恢复单行报告中被一级标题吞掉的编号章节，不猜测列表或表格边界。
export function repairCollapsedReportHeadings({ source, tokens }) {
  const blocks = tokens.filter(token => token.type !== 'space')
  if (blocks.length !== 1 || blocks[0].type !== 'heading' || blocks[0].depth !== 1)
    return source

  const heading = blocks[0]
  if (/[\r\n]/.test(source.trim()))
    return source
  // 围栏被压进单行后，lexer 无法可靠区分原代码与正文，整份内容退出修复。
  if (/(?:^|\s)(?:`{3,}|~{3,})/.test(source))
    return source

  const bodyStart = source.indexOf(heading.text)
  if (bodyStart < 0)
    return source

  // 仅在普通文本 token 中识别章节；行内代码、链接、HTML 等不参与判断。
  const boundaries = []
  let offset = bodyStart
  for (const token of heading.tokens || []) {
    if (token.type === 'text') {
      const pattern = /[ \t]+(#{2,3})[ \t]+(?:(\d+)[.、．][ \t]+|[（(](\d+)[）)][ \t]*)/g
      for (const match of token.raw.matchAll(pattern)) {
        boundaries.push({
          start: offset + match.index,
          end: offset + match.index + match[0].indexOf('#'),
          depth: match[1].length,
          number: Number(match[2] || match[3]),
        })
      }
    }
    offset += token.raw.length
  }
  // 至少两个连续的一级编号章节，避免把正文里的单次 Markdown 示例当成报告结构。
  const sections = boundaries.filter(item => item.depth === 2)
  if (sections.length < 2 || sections.some((item, index) => item.number !== index + 1))
    return source

  let candidate = source
  for (const boundary of [...boundaries].reverse()) {
    candidate = `${candidate.slice(0, boundary.start)}\n\n${candidate.slice(boundary.end)}`
  }
  return candidate
}

export function validateCollapsedReportHeadings({ beforeTokens, afterTokens }) {
  const headings = list => list.filter(token => token.type === 'heading')
  return headings(afterTokens).length > headings(beforeTokens).length
}
